import { Divider } from "antd";
import { FC } from "react";
import { AppPartType } from "../../../types";
import { COLUMN_WIDTH } from "@lhd/features/Apps/AppForm/constants";

type Prop = {
  appPart: AppPartType;
};
const VerticalBorder: FC<Prop> = ({ appPart }) => {
  const level_border = appPart?.item_config_data?.level_vertical || 0;
  const width_x = COLUMN_WIDTH * level_border || 1;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: width_x,
        margin: "0 auto",
      }}
    >
      <div
        style={{
          width: width_x,
          background: "rgba(0, 0, 0, 0.5)",
          height: "100%",
        }}
      ></div>
    </div>
  );
};

export default VerticalBorder;
